import {
    IDatasetTypeMetadata,
    IDynamicDatasetTypeMetadata
} from 'app/extensibility/metadatas/resource-type/dataset-type-metadata';

import { adfModelTypeMap } from '../consts/adf-model-type-map-const';
import { getConnectorLegacyNameByFlag } from 'app/shared/utils/string.util';
import { ControlMetadata } from 'app/extensibility/metadatas/control/control-metadata';
import { getServiceInstance } from 'app/multi-contexts/modules/root/root.application';
import { ExposureControlService } from 'app/services/exposure-control/base-exposure-control.service';
import { sapCdcDeprecationDocLink } from 'app/shared/constants/links.const';

const copySourceControls: ControlMetadata[] = [
    {
        type: 'parameterizable',
        child: {
            type: 'select',
            bind: 'extractionMode',
            label: stringResources.Extraction_Mode,
            options: [
                {
                    label: stringResources.Usql_CompilationModeOptions_Full,
                    value: 'Full'
                },
                {
                    label: stringResources.ModelName_DelaFormatDataset,
                    value: 'Delta'
                },
                {
                    label: stringResources.Recovery,
                    value: 'Recovery'
                }
            ]
        },
        dynamicContentTextClass: 'input-spaced'
    },
    {
        type: 'parameterizable',
        child: {
            type: 'textbox',
            bind: 'subscriberProcess',
            label: stringResources.SubscriberProcess
        },
        dynamicContentTextClass: 'input-spaced'
    },
    {
        type: 'sap-projection-selection',
        parameterizable: true,
        bind: {
            projection: 'projection',
            selection: 'selection'
        }
    }
];

export const sapOdpDatasetMetadata: IDynamicDatasetTypeMetadata = async (injector) => {
    const exposureControlService = await getServiceInstance<ExposureControlService>(
        injector,
        'ExposureControlService'
    );
    const metadata: IDatasetTypeMetadata = {
        type: adfModelTypeMap.sapOdp.datasetType,
        displayName: getConnectorLegacyNameByFlag(stringResources.SapOdp_DisplayText, !__IS_FABRIC_DPE__),
        supportLinkedServiceTypes: [adfModelTypeMap.sapOdp.linkedServiceType, adfModelTypeMap.sapCdc.linkedServiceType],
        splitTablePath: true,
        separatedSchemaTableSelection: true,
        isSource: exposureControlService.enableCopySapOdp,
        isSink: false,
        datasetKind: 'table',
        icon: {
            className: 'svg-i-100x100-Sap'
        },
        isFirstClass: true,
        notSupportLookupActivity: true,
        notSupportCopySourceQuery: true,
        schemaAlias: 'context',
        supportDataFlowSource: true,
        tableAlias: 'objectName',
        schemaNameDisplay: stringResources.Context_Label,
        tableNameDisplay: stringResources.ODPName_Label,
        tableNamePlural: stringResources.ODPNames_Label,
        category: ['Database'],
        supportCreatedAsV2: true,
        notSupportPhysicalType: true,
        copySourceControls,
        dataflowSourceControls: [
            {
                type: 'dataflow-sap-odp-run-mode',
                bind: 'sapReadMode'
            },
            {
                type: 'sap-odp-key-columns',
                bind: 'sapOdpKeyColumns',
                required: true,
                hide: `{ sapReadMode.expression === 'fullLoad' }`
            }
        ],
        warningMessage: __IS_FABRIC_DPE__ ? undefined : stringResources.Connector_SapCdc_DeprecationWarning,
        warningMessageHyperlink: __IS_FABRIC_DPE__ ? undefined : sapCdcDeprecationDocLink
    };

    return metadata;
};
